import { useLocation } from "react-router-dom";

import { AppHeader } from "../../components/header/header";
import { BodySpacer } from "../../components/utilities/body-spacer";
import { capitalizeLink } from "../../_helpers/utility-methods";
import { SectionHeader, SubHeader } from "../../components/page-components/section-header";
import { AppFooter } from "../../components/footer/footer";
import { ContactForm } from "../../components/footer/contact-map";
import { NewsLetterBox } from "../../components/footer/newsletter";
export const AboutUs = () => {

    const current = useLocation().pathname;


    return (
        <div className="page-body">
           <AppHeader />
           <BodySpacer />
            <div 
                    className="page-pic-box"
                    style={{backgroundImage:'url(/images/take-off.jpg)'}}
            >
                    <div className="page-pic-bg">
                        <div className="pre-txt" />
                        <div className="page-bg-text">
                            <p>About</p>
                            <p>UEST</p>
                            <div>
                                <button className="path-btn">
                                    <a href="/">Home/</a>{capitalizeLink(current)}
                                </button>
                            </div>
                        </div>
                        <div className="pre-txt" />
                    </div>
            </div>
            <SectionHeader caption={"About Us"}/>
            <div className="section-unit">
                <div className='section-text'>
                    <p>
                        <a href="/">Universal Education Services and Travels</a> is student recruitment and placement agency that deals with the orientation, guidance and counseling of students who wish to further their studies abroad. 
                        We do offer a smooth and fast admission process for different countries such as the U.S.A, Canada, Malaysia, Turkey, Cyprus, Germany, Belgium, china, Ireland, U.K. etc. we also assist students who have different preferences for their studies and give guidance on Visa requirements and immigration issues

                    </p>
                </div>
                <img src='./images/students.jpg' className='section-image' alt='' />
            </div>
            <div className="section-unit">
                <img src='./images/counseling.jpg' className='section-image' alt='' />
                <div className="section-text">
                    <SubHeader caption={"Our Mission"} />
                    <p className="sub-par">
                        As an agent specialized in the recruitment and placement of students who wish to further their studies abroad and add value to their credentials. UEST was created in order to satisfy the growing interest of Africans and Cameroonians especially in foreign education. The need for international education with an international perspective, the need for international exposure and for education consultants who will provide you with relevant advice with a personalized touch
                    </p>
                    <p className="sub-par">
                        We, at UNIVERSAL EDUCATION SERVICES AND TRAVELS believe that education is a long-term investment in the life of a human being and in his career, which will open doors for employment opportunities and personal development. We will advise the institutions, to meet the academic needs of students and the development of their quarry. We strive to be the best in providing quality service to students all over Cameroon and abroad, a service worthy of the trust of our students and confirm that they have made the right decision to use our services to study abroad. Looking forward to welcoming you to our office, we sincerely wish you the best in your aspirations and ambitions through an international education.
                    </p>
                </div>
            </div>
           <NewsLetterBox />
           <ContactForm />
           <AppFooter />
        </div>
    );
}